import React from "react";
import styles from "../styles/jobApplicationStats.module.css";
import { Bar, Doughnut } from "react-chartjs-2";

const StatCard = ({ title, value, change, iconClass, changeColor }) => (
  <div className={styles.statCard}>
    <div className={styles.cardHeader}>
      <span className={styles.cardTitle}>{title}</span>
      {iconClass && <i className={`${iconClass} ${styles.cardIcon}`}></i>}
    </div>
    <div className={styles.cardValue}>{value || 0}</div>

    {change !== null && change !== undefined && (
      <div className={styles.cardChange} style={{ color: changeColor }}>
        <i
          className={`fas ${change >= 0 ? "fa-arrow-up" : "fa-arrow-down"}`}
        ></i>{" "}
        {Math.abs(change)}% vs last period
      </div>
    )}
  </div>
);

const OverviewTab = ({ stats, charts }) => {
  return (
    <div className={styles.dashboardGrid}>
      <StatCard
        title="Today's Applications"
        value={stats.dailyCount}
        change={null}
        changeColor="#ef4444"
        iconClass="fas fa-sun"
      />
      <StatCard
        title="Monthly Total"
        value={stats.monthlyCount}
        change={null}
        changeColor="#10b981"
        iconClass="fas fa-calendar-check"
      />
      <StatCard
        title="Total Applications"
        value={stats.totalApplications}
        change={null}
        iconClass="fas fa-rocket"
      />
      <StatCard
        title="Credits Left"
        value={stats.availableJobs}
        change={null}
        iconClass="fas fa-coins"
      />

      <div className={`${styles.statCard} ${styles.largeCard}`}>
        <div className={styles.cardHeader}>
          <span className={styles.cardTitle}>Activity (Last 7 Days)</span>
        </div>
        <div className={styles.chartContainer}>
          {charts && charts.barChartData ? (
            <Bar options={charts.barChartOptions} data={charts.barChartData} />
          ) : (
            <p
              style={{ textAlign: "center", marginTop: "40px", color: "#999" }}
            >
              No activity data yet
            </p>
          )}
        </div>
      </div>

      <div className={`${styles.statCard} ${styles.largeCard}`}>
        <div className={styles.cardHeader}>
          <span className={styles.cardTitle}>Plan Usage</span>
        </div>
        <div className={styles.chartContainer}>
          {charts && charts.doughnutChartData ? (
            <Doughnut
              options={charts.doughnutChartOptions}
              data={charts.doughnutChartData}
            />
          ) : (
            <p
              style={{ textAlign: "center", marginTop: "40px", color: "#999" }}
            >
              Loading chart...
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
